module.exports = __webpack_public_path__ + "static/media/codakLens.c12c95a4.png";